export class AbstractBlock {
  constructor (
    { id, type, kind, part, die, color, time, startup, shutdown, start, description, bom, job, client, customLabel },
    prev = null,
    next = null) {
    if (new.target === AbstractBlock) {
      throw new TypeError('Cannot instantiate AbstractBlock directly')
    }

    this.link(prev, next)

    this.id = id
    this.type = type
    this.kind = kind
    this.part = part
    this.die = die
    this.color = color
    this.time = time
    this.startup = startup || 0
    this.shutdown = shutdown || 0
    this.start = +start
    this.description = description
    this.bom = bom || null
    this.job = job || null
    this.client = client || null
    this.customLabel = customLabel || null
  }

  get obj () {
    return {
      id: this.id,
      kind: this.kind,
      type: this.type,
      part: this.part,
      die: this.die,
      color: this.color,
      time: this.time,
      startup: this.startup || 0,
      shutdown: this.shutdown || 0,
      start: +this.start,
      description: this.description || '',
      client: this.client || '',
      bom: this.bom,
      job: this.job,
      customLabel: this.customLabel
    }
  }

  get end () {
    return this.start + this.startup + this.time + this.shutdown
  }

  get dimColor () {
    return this.color.replace('rgb', 'rgba').split(')')[0] + ', 0.5)'
  }

  /**
   *
   * @param i
   * @param id
   * @returns {Array}
   */
  getCells (i, id) {
    return []
  }

  /**
   *
   * @param block
   */
  append (block) {

  }

  /**
   *
   * @param block
   */
  prepend (block) {

  }

  /**
   *
   * @param prev
   * @param next
   */
  link (prev, next) {
    this.linkPrev(prev)
    this.linkNext(next)
  }

  /**
   *
   * @param next
   */
  linkNext (next) {
    this._next = next
    if (next) {
      this._next._prev = this
    }
  }

  /**
   *
   * @param prev
   */
  linkPrev (prev) {
    this._prev = prev
    if (prev) {
      this._prev._next = this
    }
  }

  /**
   *
   * @param block
   */
  resolve (block) {

  }

  /**
   *
   * @param block
   * @returns {boolean}
   */
  eq (block) {
    return block.id === this.id
  }

  bubbleNext () {
    if (this._prev) {
      if (this.time <= 0) {
        this._prev.linkNext(this._next)
        return
      }

      if (this.eq(this._prev)) {
        this._prev.time += this.time
        this._prev.linkNext(this._next)
      }
    }

    if (this._next) {
      this._next.bubbleNext()
    }
  }

  print () {
    let ret = `--[${this.type} ${this.part}]`

    if (this._next) {
      ret += this._next.print()
    } else {
      ret += '--'
    }

    return ret
  }

  remove () {
    if (this._next) {
      this._next.linkPrev(this._prev)
      this._next.pull(this.start)
    } else if (this._prev) {
      this._prev.linkNext(null)
    } else {
      this.time = 0
    }
  }

  pull (time) {

  }

  /**
   *
   * @param start
   */
  changeStart (start) {

  }

  /**
   *
   * @param end
   */
  changeEnd (end) {
    if (!end || end === this.end || isNaN(end)) {
      return
    }

    if (end <= this.start) {
      this.remove()
      return
    }

    if (end < this.end) {
      this.time -= this.end - end
      if (this._next) {
        this._next.pull(this.end)
      }
    } else {
      this.time += end - this.end
      if (this._next) {
        this._next.bubbleNext()
      }
    }
  }

  get isOutage () {
    if (this.type === 'floating') {
      return false
    }
    let current = this
    while (current._next) {
      if (this.type === 'floating') {
        return false
      }
      current = current._next
    }

    return true
  }
}
